<template>
  <div class="print:hidden flex flex-col gap-y-3 fixed bottom-2 right-2 left-auto z-[999]">
    <ButtonToTop />

    <ButtonFloatCart />

    <GeminiAssistant />
  </div>
</template>
